// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-list .export-form {\n  text-align: center;\n}\n.task-list .export-form .el-dialog__body {\n    padding: 20px 20px 0;\n}\n.task-list .export-form .el-dialog__body h3 {\n      text-align: center;\n      font-size: 16px;\n      color: #333;\n      margin: 25px 0;\n}\n.task-list .export-form .el-dialog__footer {\n    text-align: center !important;\n}\n", ""]);
// Exports
module.exports = exports;
